import React, { useState } from "react";
import { DataGrid } from "@material-ui/data-grid";

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  {
    field: "ItemImage",
    headerName: "IMG",
    width: 100,
    editable: false,
    renderCell: (params) => (
      <img style={{ maxHeight: 40 }} src={params.value} />
    ), // renderCell will render the component
  },
  {
    field: "ItemName",
    headerName: "Item",
    width: 150,
    editable: false,
  },
  {
    field: "ItemDescription",
    headerName: "Description",
    width: 200,
    editable: false,
  },
  {
    field: "ItemLocation",
    headerName: "Location",
    width: 120,
    editable: false,
  },
  {
    field: "ItemQty",
    headerName: "Avl. Qty",
    type: "number",
    width: 115,
    editable: false,
  },
  {
    field: "ItemCostPrice",
    headerName: "CP",
    type: "number",
    width: 100,
    editable: false,
    renderCell: (params) => {
      return `$ ${params.value.toFixed(2)}`;
    },
  },
  {
    field: "ItemStatus",
    headerName: "Active",
    type: "boolean",
    width: 110,
    editable: true,
  },
  {
    field: "combined",
    headerName: "Combined",
    description: "This column has a value getter and is not sortable.",
    sortable: true,
    width: 160,
    valueGetter: (params) =>
      `${params.getValue(params.id, "ItemName") || ""} ${
        params.getValue(params.id, "ItemLocation") || ""
      }`,
  },
];

// const rows = [
//   {
//     id: 1,
//     itemName: "SSD",
//     ItemLocation: "PCS WH",
//     ItemStatus: true,
//     ItemQty: 1,
//   },
// ];

const DataTable = ({ setselectedRowData, dataRows }) => {
  const [selectionModel, setSelectionModel] = useState([]);

  return (
    <div style={{ height: "70vh", width: "100%" }}>
      <DataGrid
        rows={dataRows}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[10]}
        checkboxSelection={false}
        onRowDoubleClick={() => {
          setSelectionModel([]);
          setselectedRowData(null);
        }}
        selectionModel={selectionModel}
        hideFooterSelectedRowCount
        onSelectionModelChange={(selection) => {
          if (selection.length > 1) {
            const selectionSet = new Set(selectionModel);
            const result = selection.filter((s) => !selectionSet.has(s));

            setSelectionModel(result);
          } else {
            setSelectionModel(selection);
            setselectedRowData(dataRows.find((x) => x.id === selection[0]));
          }
        }}
      />
    </div>
  );
};

export default DataTable;
